import { graphql } from "gatsby";
import React from "react";
import { Helmet } from "react-helmet";

export const query = graphql`
    fragment seo on Query {
        seo: site {
            siteMetadata {
                title
                description
                author
                siteUrl
            }
        }
    }
`;

function SEO({ description, language, title, pathname, translations, seo: { siteMetadata } }) {
    const canonical = pathname 
        ? `${siteMetadata.siteUrl}${pathname}`
        : siteMetadata.siteUrl;
    
    const links = [{ rel: "canonical", href: canonical }];
    
    if (translations && translations.length > 0) {
        translations.forEach(t => {
            const cleanLink = t.link.replace(/#$/, '');
            links.push({
                rel: "alternate",
                hreflang: t.key,
                href: `${siteMetadata.siteUrl}${cleanLink}`,
            });
        });
        
        const defaultLang = translations.find(t => t.key === "en") || translations[0];
        const defaultLink = defaultLang.link.replace(/#$/, '');
        links.push({
            rel: "alternate",
            hreflang: "x-default",
            href: `${siteMetadata.siteUrl}${defaultLink}`,
        });
    }
    
    return (
        <Helmet
            htmlAttributes={{
                lang: language,
            }}
            script={[
                { type: "text/javascript", src: "/config.js", async: true },
            ]}
            link={links}
            title={title}
            meta={[
                {
                    name: `description`,
                    content: description || siteMetadata.description,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: description || siteMetadata.description,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    property: `og:url`,
                    content: canonical,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: siteMetadata.author,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: description || siteMetadata.description,
                },
            ]}
        />
    );
}

export default SEO;
